import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import FlexView from 'react-flexview/lib';

import * as actions from '../store/actions/churgerBuilderActions';

export default function AboutOurFood() {
	const dispatch = useDispatch();

	const [clickedImg, setClickedImg] = useState(null);

	useEffect(() => {
		dispatch(actions.setPage('notOrder'));
	});

	const clickHandler = (id) =>
		clickedImg === id ? setClickedImg(null) : setClickedImg(id);

	return (
		<FlexView column margin="auto" className="about">
			<FlexView margin="auto" className="aboutDiv">
				<div
					className={`aboutImg${clickedImg === 'img1' ? ' selectedAbout' : ''}`}
					id="img1"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						Bees have built in GPS systems to track where they find their food.
						Once they find a good plug for that sweet sweet pollen, they return
						to the hive and do a little dance for the hive. The other bees can
						then watch this dance, and know exactly where to go to find the food
						source! It's fucking crazy bro.
					</div>
				</div>

				<div
					className={`aboutImg${clickedImg === 'img2' ? ' selectedAbout' : ''}`}
					id="img2"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						Monsanto is the company responsible for the creation of Agent
						Orange, which is a chemical weapon used in the Vietnam war by the
						USA, and is still causing birth defects to this day. <br /> <br />
						Monsanto owns approximately 90% of the GMO corn and soybean market
						in the USA, and have been known to sue small farms that are caught
						growing these crops, even if the wind blew the seeds there, since,
						you know... that's how crops fucking spread. <br /> <br />
						They're now owned by Bayer. The same company that brought you
						Heroin, and therefore, Opioid epidemic!
					</div>
				</div>

				<div
					className={`aboutImg${clickedImg === 'img3' ? ' selectedAbout' : ''}`}
					id="img3"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						There is a popular belief that links the origin of Bukakke to a form
						of punishment for adultery on women in medieval Japan. In fact, this
						description of its origin is false, mainly because the actual
						punishment for cheating wives was decapitation.
					</div>
				</div>
			</FlexView>
			<FlexView margin="auto" className="aboutDiv">
				<div
					className={`aboutImg${clickedImg === 'img4' ? ' selectedAbout' : ''}`}
					id="img4"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						Mexico’s multi-billion dollar avocado industry has become a prime
						target for cartels, as the avocado trade is often more profitable
						and simple than the illegal drug trade. The crop is often referred
						to as, “green gold”. So when you eat your avocado toast in the
						morning, know that some farmer and his family might have been forced
						to grow it against their will. You might as well be supporting sweat
						shops. Which you definitely do anyway.
					</div>
				</div>

				<div
					className={`aboutImg${clickedImg === 'img5' ? ' selectedAbout' : ''}`}
					id="img5"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						We actually sold some of these mirrors as a limited edition thing.
						Pretty rad.
					</div>
				</div>

				<div
					className={`aboutImg${clickedImg === 'img6' ? ' selectedAbout' : ''}`}
					id="img6"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						There are approximately 10-to-the-power-of-20 molecules of silica in
						every grain of sand. There are approximately the same number of
						grains of sand on the whole planet. The earth is just a big sand.
						The universe is just a big earth. As above, so below.
					</div>
				</div>
			</FlexView>
			<FlexView margin="auto" className="aboutDiv">
				<div
					className={`aboutImg${clickedImg === 'img7' ? ' selectedAbout' : ''}`}
					id="img7"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText" style={{ textAlign: 'left' }}>
						"Giving y'all nothing but the lick like two broads
						<br />
						Got more lyrics than the church got "Ooh, Lord"s
						<br />
						And he hold the mic and your attention like two swords
						<br />
						Either that or either one with two blades on it
						<br />
						Hey you, don't touch the mic like it's AIDS on it (Yuck)
						<br />
						It's like the end to the means
						<br />
						Fucked type of message that sends to the fiends
						<br />
						That's why he brings his own needles
						<br />
						And get more cheese than Doritos, Cheetos or Fritos
						<br />
						Slip like Freudian
						<br />
						Your first and last step to playing yourself like accordion" -DOOM
						(1971-2020)
						<br />
					</div>
				</div>

				<div
					className={`aboutImg${clickedImg === 'img8' ? ' selectedAbout' : ''}`}
					id="img8"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						Once you realize this, the universe becomes your oyster.
						All fears originate from the fear of death.
						Without fear of death, you can do anything.
					</div>
				</div>

				<div
					className={`aboutImg${clickedImg === 'img9' ? ' selectedAbout' : ''}`}
					id="img9"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						You know that little band some worms have near their head? Looks
						kind of like a scarf? That's their sex organs. They are
						hermaphrodites and dock bands with other worms to breed. Also they
						breathe through their skin and can be paralyzed by light. Don't
						worry though, we grind 'em up real nice before we put them in your
						"chicken nuggets".
					</div>
				</div>
			</FlexView>
			<FlexView margin="auto" className="aboutDiv">
				<div
					className={`aboutImg${
						clickedImg === 'img10' ? ' selectedAbout' : ''
					}`}
					id="img10"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						On April 20, 2020, the price of oil went negative. This was due to
						the fact that so many countries were on lock-down, so many oil
						consuming machines were shut down. This caused most of the sale of
						raw oil to stop, as there were no buyers. Oil well operators were
						left having to pay transporters to take the oil off the property so
						that the wells could continue operating, as pausing the excavation
						process can ruin a well's viability.
					</div>
				</div>

				<div
					className={`aboutImg${
						clickedImg === 'img11' ? ' selectedAbout' : ''
					}`}
					id="img11"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						2011: 0.08 BTC = $0.02
						<br />
						2012: 0.08 BTC = $0.41
						<br />
						2013: 0.08 BTC = $1.07
						<br />
						2014: 0.08 BTC = $61.80
						<br />
						2015: 0.08 BTC = $25.35
						<br />
						2016: 0.08 BTC = $34.67
						<br />
						2017: 0.08 BTC = $78.13
						<br />
						2018: 0.08 BTC = $1,083.69
						<br />
						2019: 0.08 BTC = $304.13
						<br />
						2020: 0.08 BTC = $575.08
						<br />
						2021: 0.08 BTC = $2,349.93
					</div>
				</div>

				<div
					className={`aboutImg${
						clickedImg === 'img12' ? ' selectedAbout' : ''
					}`}
					id="img12"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						The composer Ludwig Van Beethoven lived the last 12 years of his
						life with a rapidly worsening case of deafness. For at least the
						last nine years of his life, he and his family had to write their
						conversations in a book so that they could understand each other.
						This did not stop him from composing, however, and creating other
						artistic works. He leaves behind an extensive collection of chamber
						music, piano sonatas, and even an opera. He is remembered for the
						stoic attitude he took toward his creations, often spending years
						writing them before publishing. At one point, Archduke Rudolf,
						Prince Kinsky and Prince Lobkowitz offered to pay him a pension just
						to stay in Vienna so that they could enjoy his music. Aparrently
						they had never heard of Spotify.
					</div>
				</div>
			</FlexView>
			<FlexView margin="auto" className="aboutDiv">
				<div
					className={`aboutImg${
						clickedImg === 'img13' ? ' selectedAbout' : ''
					}`}
					id="img13"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						Lean (also known as "Purple Drank") is a drink with a long history
						dating back to the Blues scene in Houston, TX during the 1960's.
						Currently the drink is known as a combination of
						codeine-promethazine cough syrup, Jolly Rancher candies, and Spronk.
						It is often associated with musician such as Future and Juice Wrld.
						The effects are said to be relaxing, disorienting, and
						disassociative. It was brought into the mainstream during the
						1990's, thanks to DJ screw and his chopped-and-screwed music mixes.
						Sound kinda lit TBH...
					</div>
				</div>

				<div
					className={`aboutImg${
						clickedImg === 'img14' ? ' selectedAbout' : ''
					}`}
					id="img14"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						The apple in the story of Adam and Eve is what popularized the term,
						"forbidden fruit". It was likely a reference to forbidden knowledge,
						which, in the public climate of the writing of the bible, could have
						been anything from science, to finance, and even literature. Some
						speculate that it was a reference to pagan knowledge, because if you
						cut an apple in half vertically, the shape of the seed pods
						resembles a small five pointed star inside of a circle, kind of like
						a pentagram. This theory is very debatable, considering the fact
						that the Book of Genesis did not actually name the fruit, simply
						calling it "fruit" from the "forbidden tree". Christians late
						popularized the idea that it was an apple, and this would be echoed
						for centuries in other literature as well as many paintings. Idk man
						what if it was a beezechurger? No one ever asks these important
						questions. Nasty ass abple. smh
					</div>
				</div>

				<div
					className={`aboutImg${
						clickedImg === 'img15' ? ' selectedAbout' : ''
					}`}
					id="img15"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						Don't blame{' '}
						<a
							href="https://instagram.com/rezuler"
							target="_blank"
							rel="noreferrer"
						>
							me
						</a>
						. Blame capitalism.
					</div>
				</div>
			</FlexView>
			<FlexView margin="auto" className="aboutDiv">
				<div
					className={`aboutImg${
						clickedImg === 'img16' ? ' selectedAbout' : ''
					}`}
					id="img16"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						Bro, have you ever seen the eggs in Europe? They don't even clean
						them shits my g. They sell them all cover in shit and feathers on
						the shelf, not even refrigerated, I shit you not. But it's actually
						the better way. Here's why:
						<br />
						<br /> In Europe, farmers are required to give their hens the
						salmonella vaccine. By doing this, the coating on the shell of the
						egg left by the hen, known as the cuticle, protects the shell of the
						egg from harboring salmonella during transport, and since all the
						hens are vaccinated, they know that the eggs are safe to eat.
						Consumers just wash them at home, right before cooking/ eating them.
						<br />
						<br /> In the US, vaccinating hens is not a requirement. This means
						that the shell of the egg can carry salmonella from the hen that
						laid it. As a consequence, our eggs have t be washed before sale,
						which washes off the cuticle, which then means it has to be
						refrigerated to reduce the risk of salmonella from growing on the
						shell and entering the egg before human consumption.
						<br />
						<br /> So while US eggs tend to look better in the store, the
						Europeans actually have a much more sustainable and logical approach
						to keeping the eggs safe to eat, while eliminating the need for
						refrigeration. They taste better too. American eggs have a very
						fishy flavor compared to European eggs.
					</div>
				</div>

				<div
					className={`aboutImg${
						clickedImg === 'img17' ? ' selectedAbout' : ''
					}`}
					id="img17"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						Normal Oreos are vegan and Kosher. Fuck that shit. Eat some goddamn
						meat.
					</div>
				</div>

				<div
					className={`aboutImg${
						clickedImg === 'img18' ? ' selectedAbout' : ''
					}`}
					id="img18"
					onClick={(e) => clickHandler(e.target.id)}
				>
					<div className="aboutText">
						People think that the first sperm to reach the egg is that one that
						fertilizes it, but this is usually not the case. Typically, many
						sperm reach the egg around the same time and try to bind to it, one
						after another, kind of liek that scene in Game of Thrones where the
						guy is saying, "Ho door", that was your Mom's egg. Eventually, after
						the sprerm poke at the egg for a while, one of the sprerm will be
						able to bind and permeate the egg, after the cell wall has been
						'weakened' by the other sprerms. So no, you were not the fastest
						sperm. You just took credit for your brother's and sister's work.
					</div>
				</div>
			</FlexView>
		</FlexView>
	);
}
